module.exports = __webpack_public_path__ + "static/img/微信公众号.861875a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/微信公众号.png
// module id = 8el1
// module chunks = 15